export function isMarkObject(mark) {
    return Boolean(mark && typeof mark === 'object' && 'label' in mark);
}
